import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

export const StartLights = ({ onComplete, onBeep }) => {
  const [step, setStep] = useState(0);
  useEffect(() => {
    const timers = [0,1,2,3,4].map((i)=> setTimeout(()=>{ onBeep && onBeep(); setStep(i+1); }, i*1000));
    const out = setTimeout(()=>{ setStep(0); setTimeout(()=> onComplete && onComplete(), 500); }, 5*600+400);
    return () => { timers.forEach(clearTimeout); clearTimeout(out); };
  }, [onComplete, onBeep]);

  return (
    <div className="flex flex-col items-center gap-6">
      <div className="text-2xl md:text-4xl font-extrabold tracking-widest text-white">INICIANDO BUSQUEDA DE GANADORES</div>
      <div className="flex gap-4">
        {[0,1,2,3,4].map((i)=>(
          <motion.div key={i} animate={{ backgroundColor: step>i ? "#ef4444" : "#1f2937", boxShadow: step>i ? "0 0 24px rgba(239,68,68,0.9), 0 0 60px rgba(239,68,68,0.4)" : "none" }} transition={{ duration: .25 }} className="w-12 h-12 md:w-14 md:h-14 rounded-full border-2 border-gray-600" />
        ))}
      </div>
      <motion.div key={step===0?"out":"on"} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="text-white/70 text-sm md:text-base">
        {step === 0 ? "GANADORES ENCONTRADOS!" : "MOTORES LISTOS • OBTENIENDO GANADORES"}
      </motion.div>
    </div>
  );
};
